<template>
  <!-- ケアオーケストレーター詳細 -->
  <div id="CORequestAcceptDetail">
    <div id="container">
      <div class="labelTitle lable">ケア オーケストレーター 申込み受付</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <!-- 種別：施設登録／施設変更 -->
        <template v-if="orderType==coOrderType.facilityAdd || orderType==coOrderType.facilityUpdate">
          <div class="card-content margin-top relative">
              <span style="font-size:20px;">{{orderType | coOrderTypeFilter()}}</span><span v-if="isDealer">（ディーラー申込み）</span>
              <b-button class="clipBoardCopy is-primary" @click="clipboardCopy('data')">クリップボードにコピーする（Excel向け）</b-button>
              <div class="card-content margin-top">
                <table v-if="orderType==coOrderType.facilityAdd">
                    <tr><th>【施設情報】</th><td></td></tr>
                    <tr>
                      <th style="vertical-align: top;">医療機関名</th><td style="vertical-align: top; word-break: break-word;white-space:pre-wrap;word-wrap:break-word;width:350px">{{data.hospitalName}}</td>
                      <th style="vertical-align: top;">診療科</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.division}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">郵便番号</th><td style="vertical-align: top;">{{data.zip}}</td>
                      <th style="vertical-align: top;">住所</th><td style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.prefecture}}{{data.city}}{{data.address1}}{{data.address2}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">電話番号</th><td style="vertical-align: top;">{{data.phoneNumber}}</td>
                      <th v-if="isDealer">担当支店</th><td v-if="isDealer" style="vertical-align: top;">{{data.office}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">クライアント認証</th>
                      <td style="vertical-align: top;">
                        <template v-if="data.clientAuthentication">有効にする</template>
                        <template v-else>有効にしない</template>
                      </td>
                    </tr>
                    <tr v-if="isDealer">
                      <th style="vertical-align: top;">フィリップス保守サービス</th><td style="vertical-align: top;"><template v-if="data.crossReference">有</template><template v-else>無</template></td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">備考</th><td colspan="3" style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.biko}}</div></td>
                    </tr>
                    <tr v-if="isDealer"><td colspan="4">
                        <b-checkbox class="cstmCheckBox" value="true" disabled></b-checkbox>申請者がケア オーケストレーターの申込みを行うことについて、該当医療機関の同意を取得しています。
                    </td></tr>
                </table>
                <table v-if="orderType==coOrderType.facilityUpdate">
                    <tr><th>【施設情報】</th><td></td></tr>
                    <tr><th></th><td style="font-weight: bold;">変更前</td><td style="font-weight: bold;">変更後</td></tr>
                    <tr>
                      <th style="vertical-align: top;">医療機関名</th>
                      <td style="vertical-align: top; word-break: break-word;white-space:pre-wrap;word-wrap:break-word;width:350px">{{data.beforeHospitalName}}</td>
                      <td style="vertical-align: top;">{{data.hospitalName}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">診療科</th>
                      <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.beforeDivision}}</td>
                      <td style="vertical-align: top;">{{data.division}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">郵便番号</th>
                      <td style="vertical-align: top;">{{data.beforeZip}}</td>
                      <td style="vertical-align: top;">{{data.zip}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">住所</th>
                      <td style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.beforePrefecture}}{{data.beforeCity}}{{data.beforeAddress1}}{{data.beforeAddress2}}</td>
                      <td style="vertical-align: top;">{{data.prefecture}}{{data.city}}{{data.address1}}{{data.address2}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">電話番号</th>
                      <td style="vertical-align: top;">{{data.beforePhoneNumber}}</td>
                      <td style="vertical-align: top;">{{data.phoneNumber}}</td>
                    </tr>
                    <tr v-if="isDealer">
                      <th>担当支店</th>
                      <td v-if="isDealer" style="vertical-align: top;">{{data.beforeOffice}}</td>
                      <td v-if="isDealer" style="vertical-align: top;">{{data.office}}</td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">クライアント認証</th>
                      <td style="vertical-align: top;">
                        <template v-if="data.beforeClientAuthentication">有効にする</template><template v-else>有効にしない</template></td>
                      <td style="vertical-align: top;">
                        <template v-if="data.clientAuthentication">有効にする</template><template v-else>有効にしない</template></td>
                    </tr>
                    <tr v-if="isDealer">
                      <th style="vertical-align: top;">フィリップス保守サービス</th>
                      <td style="vertical-align: top;">
                        <template v-if="data.beforeCrossReference">有</template><template v-else>無</template></td>
                      <td style="vertical-align: top;">
                        <template v-if="data.crossReference">有</template><template v-else>無</template></td>
                    </tr>
                    <tr>
                      <th style="vertical-align: top;">備考</th>
                      <td style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">
                        <div class="indentionArea printIndentionArea">{{data.beforeBiko}}</div></td>
                      <td style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">
                        <div class="indentionArea printIndentionArea">{{data.biko}}</div></td>
                    </tr>
                    <tr v-if="isDealer"><td colspan="4">
                        <b-checkbox class="cstmCheckBox" value="true" disabled></b-checkbox>申請者がケア オーケストレーターの申込みを行うことについて、該当医療機関の同意を取得しています。
                    </td></tr>
                </table>
              </div>
          </div>
          <div class="card-content margin-top relative">
            <table>
              <tr><th>担当連絡先</th>
                <td v-if="data.staffName">{{data.staffName}} （ {{data.staffAddress}} ）</td>
                <td v-else></td>
              </tr>
            </table>
          </div>
          <div v-if="orderType == coOrderType.facilityAdd && (status == coStatus.requestConfirmed || status == coStatus.added || status == coStatus.cancel)" class="card-content margin-top">
            <table v-if="status == coStatus.requestConfirmed">
                <tr><th>支店ユーザーID<span class="require" /></th><td><input type="text" class="edit" name="支店ユーザーID" validate="required" v-model="branchUserid" maxlength="100"/></td></tr>
                <tr><th>仮パスワード<span class="require" /></th><td><input type="text" class="edit" name="仮パスワード" validate="required" v-model="provisionalPwd" maxlength="256"/></td></tr>
                <tr><th style="vertical-align:top;">通信欄(備考)</th><td><textarea v-model="data.communicationNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"/></td></tr>
            </table>
            <table v-else>
                <tr><th>支店ユーザーID</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.registedCoUserId}}</td></tr>
                <tr><th>仮パスワード</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.tempPassword}}</td></tr>
                <tr><th style="vertical-align:top;">通信欄(備考)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.communicationNote}}</div></td></tr>
            </table>
          </div>
          <div v-else-if="orderType == coOrderType.facilityUpdate && (status == coStatus.requestConfirmed || status == coStatus.added || status == coStatus.cancel)" class="card-content margin-top">
            <table v-if="status == coStatus.requestConfirmed">
              <tr><th style="vertical-align:top;">通信欄(備考)</th><td><textarea v-model="data.communicationNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"/></td></tr>
            </table>
            <table v-else>
              <tr><th style="vertical-align:top;">通信欄(備考)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.communicationNote}}</div></td></tr>
            </table>
          </div>
          <!-- ボタン表示エリア -->
          <div v-if="status == coStatus.requestPending || status == coStatus.requestConfirmed" class="button-area">
            <b-button v-if="status == coStatus.requestPending" class="is-primary" v-on:click="changeStatusToConfirmed">確認済みにする</b-button>
            <template v-if="status == coStatus.requestConfirmed">
              <b-button v-if="orderType == coOrderType.facilityAdd" class="is-primary" v-on:click="addHospital">登録済みにする</b-button>
              <b-button v-if="orderType == coOrderType.facilityUpdate" class="is-primary" v-on:click="confHospital">変更済みにする</b-button>
            </template>
            <router-link :to="{ name: 'CORequestAcceptEdit', params: { item, data, userInfo, isDealer, searchConditions: this.searchConditions } }">
              <b-button v-if="orderType == coOrderType.facilityAdd" class="is-primary">編集する</b-button>
            </router-link>
            <b-button class="is-primary" v-on:click="requestCancel">取り消し</b-button>
          </div>
          <div v-if="status == coStatus.cancel" class="button-area">
            <b-button class="is-primary" v-on:click="undoCancel">キャンセル取消</b-button>
          </div>
          <section>
          <div class="forClipBoardCopy">
              <table v-if="orderType==coOrderType.facilityAdd || orderType==coOrderType.facilityUpdate" id="data">
                <tr>
                  <td><!-- 種別 -->
                      <template v-if="orderType==coOrderType.facilityAdd">施設登録</template>
                      <template v-if="orderType==coOrderType.facilityUpdate">施設変更</template>
                  </td>
                  <td>{{clientName}}</td><!-- 依頼元 -->
                  <td>{{data.hospitalName}}</td><!-- 医療機関名 -->
                  <td>{{data.sapName}}</td><!-- 正式名称 -->
                  <td></td><!-- #空白 -->
                  <td>{{data.zip}}</td><!-- 郵便番号 -->
                  <td>{{data.prefecture}}</td><!-- 都道府県 -->
                  <td>{{data.city}}</td><!-- 市町村 -->
                  <td>{{data.address1}}</td><!-- 住所1 -->
                  <td>{{data.address2}}</td><!-- 住所2 -->
                  <td>{{data.phoneNumber}}</td><!-- TEL -->
                  <td>{{data.sapNumber}}</td><!-- SAP番号 -->
                  <td><template v-if="data.clientAuthentication">有効にする</template><template v-else>有効にしない</template></td><!-- CL認証 -->
                  <td><template v-if="isDealer"><template v-if="data.crossReference">有</template><template v-else>無</template></template></td><!-- フィリップス保守サービス -->
                  <td><template>{{data.officeName}}</template></td><!-- 支店名 -->
                  <td><template v-if="!isDealer">{{data.staffName}}</template></td><!-- 担当者名 -->
                  <td>{{data.biko}}</td><!-- 備考 -->
                </tr>
              </table>
          </div>
          </section>
        </template>
        <!-- 種別：ユーザー追加 -->
        <template v-if="orderType==coOrderType.userAdd">
          <div class="card-content margin-top relative">
            <span style="font-size:20px;">{{orderType | coOrderTypeFilter()}}</span><span v-if="isDealer">（ディーラー申込み）</span>
            <b-button class="clipBoardCopy is-primary" @click="clipboardCopy('userInfo')">クリップボードにコピーする（Excel向け）</b-button>
            <table>
                <tr><th>姓</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.familyName}}</td></tr>
                <tr><th>名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.firstName}}</td></tr>
                <tr v-if="isDealer"><th>ユーザー区分</th><td>{{data.userClassification}}</td></tr>
                <tr><th>処方設定</th><td><template v-if="userInfo.prescriptionSettings">操作可</template><template v-else>操作不可</template></td></tr>
                <tr><th>希望ユーザーID(第一希望)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.userIDFirstChoice}}</td></tr>
                <tr><th>希望ユーザーID(第二希望)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.userIDSecondChoice}}</td></tr>
                <tr><th>希望ユーザーID(第三希望)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.userIDThirdChoice}}</td></tr>
                <tr><th>メールアドレス</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.mail}}</td></tr>
                <tr v-if="!isDealer">
                  <th style="vertical-align: top;">ケア　エクスポーター</th>
                  <td style="vertical-align: top;">
                    <template v-if="userInfo.careExporter">利用する</template>
                    <template v-else>利用しない</template>
                  </td>
                </tr>
            </table>
          </div>
          <div  class="card-content margin-top relative">
            <table>
              <tr><th>【施設情報】</th><td></td></tr>
              <tr><th style="vertical-align:top;padding-left:15px;">医療機関名</th><td style="vertical-align: top; word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
              <tr><th style="vertical-align:top;padding-left:15px;">住所</th><td style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.prefecture}}{{data.city}}{{data.address1}}{{data.address2}}</td></tr>
              <tr><th style="vertical-align:top;padding-left:15px;">電話番号</th><td style="vertical-align: top;">{{data.phoneNumber}}</td></tr>
            </table>
          </div>
          <div  class="card-content margin-top relative">
            <table>
              <tr><th>担当連絡先</th>
                <td v-if="data.staffName">{{data.staffName}} （ {{data.staffAddress}} ）</td>
                <td v-else></td>
              </tr>
            </table>
          </div>
          <div v-if="orderType == coOrderType.userAdd && (status == coStatus.requestConfirmed || status == coStatus.added || status == coStatus.cancel)" class="card-content margin-top">
            <table v-if="status == coStatus.requestConfirmed" >
                <tr><th>ユーザーID<span class="require" /></th><td><input type="text" class="editUser" name="ユーザーID" validate="required" v-model="UbranchUserid" maxlength="100"/></td></tr>
                <tr><th>仮パスワード<span class="require" /></th><td><input type="text" class="editUser" name="仮パスワード" validate="required" v-model="UprovisionalPwd" maxlength="256"/></td></tr>
                <tr><th style="vertical-align:top;">通信欄(備考)</th><td><textarea v-model="data.communicationNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"/></td></tr>
            </table>
            <table v-else>
                <tr><th>ユーザーID</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.registedCoUserId}}</td></tr>
                <tr><th>仮パスワード</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.tempPassword}}</td></tr>
                <tr><th style="vertical-align:top;">通信欄(備考)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.communicationNote}}</div></td></tr>
            </table>
          </div>
          <!-- ボタン表示エリア -->
          <div v-if="status == coStatus.requestPending || status == coStatus.requestConfirmed" class="button-area">
            <b-button v-if="status == coStatus.requestPending" class="is-primary" v-on:click="changeStatusToConfirmed">確認済みにする</b-button>
            <template v-if="status == coStatus.requestConfirmed">
              <b-button class="is-primary" v-on:click="addUser">登録済みにする</b-button>
            </template>
            <router-link :to="{ name:'CORequestAcceptEdit', params: { item, data, userInfo, isDealer, userClassification: this.data.userClassification, searchConditions: this.searchConditions } }">
              <b-button class="is-primary">編集する</b-button>
            </router-link>
            <b-button class="is-primary" v-on:click="requestCancel">取り消し</b-button>
          </div>
          <div v-if="status == coStatus.cancel" class="button-area">
            <b-button class="is-primary" v-on:click="undoCancel">キャンセル取消</b-button>
          </div>
          <section>
            <div class="forClipBoardCopy">
              <table id="userInfo">
                  <td>ユーザー追加</td><!-- 種別 -->
                  <td>{{clientName}}</td><!-- 依頼元 -->
                  <td>{{data.hospitalName}}</td><!-- 表示名 -->
                  <td>{{data.sapName}}</td><!-- 正式名 -->
                  <td></td><!-- #空白 -->
                  <td>{{userInfo.familyName}}</td><!-- 姓 -->
                  <td>{{userInfo.firstName}}</td><!-- 名 -->
                  <td>{{userInfo.mail}}</td><!-- E mail -->
                  <td>{{userInfo.userIDFirstChoice}}</td><!-- ID-1 -->
                  <td>{{userInfo.userIDSecondChoice}}</td><!-- ID-2 -->
                  <td>{{userInfo.userIDThirdChoice}}</td><!-- ID-3 -->
                  <td><template v-if="isDealer">{{data.userClassification}}</template></td><!-- ユーザー区分 -->
                  <td><template v-if="userInfo.prescriptionSettings">操作可</template><template v-else>操作不可</template></td><!-- 処方設定 -->
              </table>
            </div>
          </section>
        </template>
        <!-- 種別：ユーザー変更／ユーザー削除 -->
        <template v-if="orderType==coOrderType.userDel || orderType==coOrderType.userUpdate">
          <div class="card-content margin-top relative">
            <span style="font-size:20px;">{{orderType | coOrderTypeFilter()}}</span><span v-if="isDealer">（ディーラー申込み）</span>
            <b-button class="clipBoardCopy is-primary" @click="clipboardCopy('userInfo')">クリップボードにコピーする（Excel向け）</b-button>
            <div v-if="orderType==coOrderType.userUpdate" style="height:4px"></div>
            <table>
                <tr v-if="orderType==coOrderType.userUpdate"><th></th><td style="font-weight: bold;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">変更前</td>
                <td style="font-weight: bold;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">変更後</td></tr>
                <tr><th>ユーザーID</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.registedCoUserId}}</td></tr>
                <tr><th>姓</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.familyName}}</td></tr>
                <tr><th>名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.firstName}}</td></tr>
                <tr v-if="isDealer"><th>ユーザー区分</th><td>{{data.beforeUserClassification}}</td>
                <td v-if="orderType==coOrderType.userUpdate" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.userClassification}}</td></tr>
                <tr><th>処方設定</th><td v-if="orderType==coOrderType.userUpdate"><template v-if="userInfo.beforePrescriptionSettings">操作可</template><template v-else>操作不可</template></td>
                <td><template v-if="userInfo.prescriptionSettings">操作可</template><template v-else>操作不可</template></td></tr>
                <tr><th>メールアドレス</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.beforeMail}}</td>
                <td v-if="orderType==coOrderType.userUpdate" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{userInfo.mail}}</td></tr>
                <tr v-if="!isDealer">
                  <th>ケア　エクスポーター</th>
                  <td v-if="orderType == coOrderType.userUpdate">
                    {{ userInfo.beforeCareExporter ? "利用する" : "利用しない" }}
                  </td>
                  <td>
                    {{ userInfo.careExporter ? "利用する" : "利用しない" }}
                  </td>
                </tr>
            </table>
          </div>
          <div  class="card-content margin-top relative">
            <table>
              <tr><th>【施設情報】</th><td></td></tr>
              <tr><th style="vertical-align:top;padding-left:15px;">医療機関名</th><td style="vertical-align: top; word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
              <tr><th style="vertical-align:top;padding-left:15px;">住所</th><td style="vertical-align: top;word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.prefecture}}{{data.city}}{{data.address1}}{{data.address2}}</td></tr>
              <tr><th style="vertical-align:top;padding-left:15px;">電話番号</th><td style="vertical-align: top;">{{data.phoneNumber}}</td></tr>
            </table>
          </div>
          <div  class="card-content margin-top relative">
            <table>
              <tr><th>担当連絡先</th>
                <td v-if="data.staffName">{{data.staffName}} （ {{data.staffAddress}} ）</td>
                <td v-else></td>
              </tr>
            </table>
          </div>
          <div v-if="status == coStatus.requestConfirmed || status == coStatus.added || status == coStatus.cancel" class="card-content margin-top">
            <table v-if="status == coStatus.requestConfirmed" >
              <tr><th style="vertical-align:top;">通信欄(備考)</th><td><textarea v-model="data.communicationNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"/></td></tr>
            </table>
            <table v-else>
              <tr><th style="vertical-align:top;">通信欄(備考)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.communicationNote}}</div></td></tr>
            </table>
          </div>
          <!-- ボタン表示エリア -->
          <div v-if="status == coStatus.requestPending || status == coStatus.requestConfirmed" class="button-area">
            <b-button v-if="status == coStatus.requestPending" class="is-primary" v-on:click="changeStatusToConfirmed">確認済みにする</b-button>
            <template v-if="status == coStatus.requestConfirmed">
              <b-button v-if="orderType == coOrderType.userUpdate" class="is-primary" v-on:click="confUser">変更済みにする</b-button>
              <b-button v-if="orderType == coOrderType.userDel" class="is-primary" v-on:click="delUser">削除済みにする</b-button>
            </template>
            <b-button class="is-primary" v-on:click="requestCancel">取り消し</b-button>
          </div>
          <div v-if="status == coStatus.cancel" class="button-area">
            <b-button class="is-primary" v-on:click="undoCancel">キャンセル取消</b-button>
          </div>
          <section>
            <div class="forClipBoardCopy">
              <table id="userInfo">
                  <td><!-- 種別 -->
                    <template v-if="orderType==coOrderType.userUpdate">ユーザー変更</template>
                    <template v-if="orderType==coOrderType.userDel">ユーザー削除</template>
                  </td>
                  <td>{{clientName}}</td><!-- 依頼元 -->
                  <td>{{data.hospitalName}}</td><!-- 表示名 -->
                  <td>{{data.sapName}} </td><!-- 正式名 -->
                  <td></td><!-- #空白 -->
                  <td>{{userInfo.familyName}}</td><!-- 姓 -->
                  <td>{{userInfo.firstName}}</td><!-- 名 -->
                  <td>{{userInfo.mail}}</td><!-- E mail -->
                  <td>{{data.registedCoUserId}}</td><!-- ID-1 -->
                  <td></td><!-- ID-2 -->
                  <td></td><!-- ID-3 -->
                  <td><template v-if="isDealer">{{data.userClassification}}</template></td><!-- ユーザー区分 -->
                  <td><template v-if="userInfo.prescriptionSettings">操作可</template><template v-else>操作不可</template></td><!-- 処方設定 -->
              </table>
            </div>
          </section>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { coStatus } from "@/components/mock/base/const.js";
import { coOrderType } from "@/components/mock/base/const.js";

export default {
  name: "CORequestAcceptDetail",
  props: {
    item: Object,
    searchConditions: Object
  },
  methods: {
    back: function () {
      this.$router.push({
        name: "CORequestAccept",
        params: { searchConditions: this.searchConditions },
      });
    },
    changeStatusToConfirmed: function() {
      const executeApi = this.updateCoConfirmedPOST;
      const successCallBack = this.commonCoPOSTSuccess;
      const errorCallBack = this.commonCoPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    commonCoPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.editMode = false;
      this.back();
    },
    commonCoPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    updateCoConfirmedPOST: function(client) {
      const body = JSON.parse(JSON.stringify({
        receiptNumber: this.targetNumber,
        kind: this.orderType,
        version: this.data.version,
      }));
      return client.apis.internalCo.updateCoConfirmedPOST({ body });
    },
    addHospital: function(){
      // バリデーションチェック
      const elements = document.getElementsByClassName("edit");
      const result = this.selfMadeValidation(elements);
      if(result.isError){
        this.showErrorMessage(result.msg)
      }else{
        const executeApi = this.setCoRegisteredPOST;
        const successCallBack = this.setCoRegisteredPOSTSuccess;
        const errorCallBack = this.setCoRegisteredPOSTError;
        // Web Api Call
        this.apiCall(executeApi, successCallBack, errorCallBack);
      }
    },
    setCoRegisteredPOST: function(client) {
      const obj = JSON.parse(JSON.stringify(this.data));
      obj.kind = this.orderType;
      obj.receiptNumber = this.targetNumber;
      obj.branchUserid = this.branchUserid ? this.branchUserid : this.UbranchUserid;
      obj.provisionalPwd = this.provisionalPwd ? this.provisionalPwd : this.UprovisionalPwd;
      obj.client = this.clientName;
      obj.isDealer = this.isDealer ;
      obj.contact = this.isDealer ? this.data.officeName : this.data.staffName;
      obj.mail = this.isDealer ? this.data.officeAddress : this.data.staffAddress;
      obj.userInfo = this.userInfo;
      return client.apis.internalCo.setCoRegisteredPOST({
        body: obj
      });
    },
    setCoRegisteredPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.editMode = false;
      this.back();
    },
    setCoRegisteredPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    confHospital: function(){
        const executeApi = this.setCoUpdatedPOST;
        const successCallBack = this.setCoUpdatedPOSTSuccess;
        const errorCallBack = this.setCoUpdatedPOSTError;
        // Web Api Call
        this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    setCoUpdatedPOST: function(client) {
      const obj = JSON.parse(JSON.stringify(this.data));
      obj.kind = this.orderType;
      obj.receiptNumber = this.targetNumber;
      obj.branchUserid = this.branchUserid ? this.branchUserid : this.UbranchUserid;
      obj.client = this.clientName;
      obj.isDealer = this.isDealer ;
      obj.contact = this.isDealer ? this.data.officeName : this.data.staffName;
      obj.mail = this.isDealer ? this.data.officeAddress : this.data.staffAddress;
      obj.userInfo = this.userInfo;
      obj.changeCertification = this.data.beforeClientAuthentication != this.data.clientAuthentication; //クライアント認証が変更されているかどうか
      return client.apis.internalCo.setCoUpdatedPOST({
        body:obj
      });
    },
    setCoUpdatedPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.editMode = false;
      this.back();
    },
    setCoUpdatedPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    addUser: function(){
      // バリデーションチェック
      const elements = document.getElementsByClassName("editUser");
      const result = this.selfMadeValidation(elements);
      if(result.isError){
        this.showErrorMessage(result.msg)
      }else{
        const executeApi = this.setCoRegisteredPOST;
        const successCallBack = this.setCoRegisteredPOSTSuccess;
        const errorCallBack = this.setCoRegisteredPOSTError;
        // Web Api Call
        this.apiCall(executeApi, successCallBack, errorCallBack);
      }
    },
    confUser: function(){
      const executeApi = this.setCoUpdatedPOST;
      const successCallBack = this.setCoUpdatedPOSTSuccess;
      const errorCallBack = this.setCoUpdatedPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    delUser: function(){
      const executeApi = this.setCoDeletedPOST;
      const successCallBack = this.setCoDeletedPOSTSuccess;
      const errorCallBack = this.setCoDeletedPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    setCoDeletedPOST: function(client) {
      const obj = JSON.parse(JSON.stringify(this.data));
      obj.kind = this.orderType;
      obj.receiptNumber = this.targetNumber;
      obj.client = this.clientName;
      obj.isDealer = this.isDealer;
      obj.contact = this.isDealer ? this.data.officeName : this.data.staffName;
      obj.mail = this.isDealer ? this.data.officeAddress : this.data.staffAddress;
      obj.userInfo = this.userInfo;
      obj.staffUserId = this.data.staffUserId;
      return client.apis.internalCo.setCoDeletedPOST({
        body:obj
      });
    },
    setCoDeletedPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.editMode = false;
      this.back();
    },
    setCoDeletedPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    requestCancel: function(){
      const executeApi = this.setCoCancelPOST;
      const successCallBack = this.setCoCancelPOSTSuccess;
      const errorCallBack = this.setCoCancelPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    setCoCancelPOST: function(client) {
      const obj = JSON.parse(JSON.stringify(this.data));
      obj.kind = this.orderType;
      obj.receiptNumber = this.targetNumber;
      return client.apis.internalCo.setCoCancelPOST({
        body:obj
      });
    },
    setCoCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.editMode = false;
      this.back();
    },
    setCoCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    // キャンセルの取り消し
    undoCancel: function() {
      const executeApi = this.updateCoUndoCancelPOST;
      const successCallBack = this.commonCoPOSTSuccess;
      const errorCallBack = this.commonCoPOSTError;
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    updateCoUndoCancelPOST: function(client) {
      const body = JSON.parse(JSON.stringify({
        kind: this.orderType,
        receiptNumber: this.targetNumber,
        careOrchestratorInstitutionId: this.data.careOrchestratorInstitutionId,
        userId: this.userInfo.userId ? this.userInfo.userId : undefined,
        version: this.data.version,
      }));
      return client.apis.internalCo.updateCoUndoCancelPOST({ body });
    },
    doSearch: function() {
      const executeApi = this.getCoApplicationDetailPOST;
      const successCallBack = this.getCoApplicationDetailPOSTSuccess;
      const errorCallBack = this.getCoApplicationDetailPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    getCoApplicationDetailPOST: function(client) {
      return client.apis.internalCo.getCoApplicationDetailPOST({
        body:{receiptNumber: this.targetNumber, orderType: this.orderType}
      });
    },
    getCoApplicationDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.userInfo = this.data.userInfoList
      this.isDealer = this.data.isDealer
    },
    getCoApplicationDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    clipboardCopy: function(elementId){
      const table = document.getElementById(elementId);
      navigator.clipboard.writeText(table.innerText).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
        console.log(err);
      });
    }
  },
  data() {
    return {
      data:[],
      userInfo:[],
      // 申請状態
      status: "",
      // 申請種別
      orderType: "",
      // ディーラー判別
      isDealer: "",
      // 受付番号
      targetNumber: "",
      clientName: "",
      // 支店ユーザーID(施設)
      branchUserid:"",
      // 仮パスワード(施設)
      provisionalPwd:"",
      // 支店ユーザーID(ユーザー)
      UbranchUserid:"",
      // 仮パスワード(ユーザー)
      UprovisionalPwd:"",
    };
  },
  async mounted() {
    await this.doSearch();
  },
  created() {
    this.targetNumber = this.item.receiptNumber;
    this.status = String(this.item.applicationStatus);
    this.orderType = this.item.kind;
    this.isDealer = false;
    this.clientName = this.item.client;
  },
  // NOTE: const.jsから参照する以下の値は定数のため、dataには置かずにcomputedプロパティで使用する。
  computed: {
    coStatus() {
      return coStatus;
    },
    coOrderType() {
      return coOrderType;
    }
  }
};
</script>

<style lang="scss" scoped>

.relative {
  position: relative;
}
.clipBoardCopy {
  position: absolute;
  right: 10px;
  width: 350px;
}
.forClipBoardCopy {
  display: block;
  position:absolute;
  top: -99999px;
  left: -99999px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/CORequestAcceptDetail.vue